import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

const SESSION_KEY_PUBLIC_IP = 'publicIp';
const IPIFY_URL = 'https://api.ipify.org';

/**
 * Centralized public IP: fetched once at app start, stored in sessionStorage
 * so cadastral, change-of-address, cadastral-trial, geographic-vn2 can reuse it
 * instead of calling the IP API on every page.
 */
@Injectable({
    providedIn: 'root',
})
export class PublicIpService {
    constructor(private http: HttpClient) {}

    /**
     * Returns the stored public IP, or empty string if not yet loaded.
     */
    getPublicIp(): string {
        return sessionStorage.getItem(SESSION_KEY_PUBLIC_IP) || '';
    }

    /**
     * Fetches public IP from ipify, stores it in sessionStorage under 'publicIp'.
     * Skips the request if a value is already stored (reuse for the session).
     */
    loadPublicIp(): void {
        if (sessionStorage.getItem(SESSION_KEY_PUBLIC_IP)) {
            return;
        }
        this.http.get(IPIFY_URL, { responseType: 'text' }).subscribe({
            next: (ip) => {
                sessionStorage.setItem(SESSION_KEY_PUBLIC_IP, ip);
            },
            error: (err) => console.error('Error getting public IP:', err),
        });
    }

    /**
     * Returns a random public-looking IP (non-private). Used when localStorage 'test' is 'true'.
     */
    getRandomPublicIp(): string {
        const randomOctet = () => Math.floor(Math.random() * 256);
        let ip = '';
        do {
            ip = `${randomOctet()}.${randomOctet()}.${randomOctet()}.${randomOctet()}`;
        } while (
            ip.startsWith('10.') ||
            ip.startsWith('192.168.') ||
            ip.startsWith('172.16.') ||
            ip.startsWith('172.31.')
        );
        return ip;
    }
}
